let forms = {
	sendMessage: {
		icon: 'fa fa-envelope',
		title: 'Contact Us',
		subtitle: 'Send us a message',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12 col-md-6',
				model: 'first_name',
				validation: 'required|min:3|max:150',
				label: 'First Name',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12 col-md-6',
				model: 'last_name',
				validation: 'required|min:3|max:150',
				label: 'Last Name',
			},
			{
				type: 'text',
				form_type: 'email',
				class: 'col-12',
				model: 'email',
				validation: 'required|min:3|max:150|email',
				label: 'Email Address',
			},
			{
				type: 'select',
				class: 'col-12',
				model: 'category',
				filterable: true,
				clearable: true,
				options: [
					{ label: 'General Inquiry', value: 'general' },
					{ label: 'Support', value: 'support' },
					{ label: 'Partnership', value: 'partnership' },
					{ label: 'Other', value: 'other' },
				],
				validation: 'required',
				label: 'Category',
			},
			{
				type: 'textarea',
				class: 'col-12',
				model: 'message',
				validation: 'required|min:10|max:500',
				label: 'Message',
			},
		],
	},
};

export default forms;
